import React from "react";
import northStarSign from "../../../../static/north-star.png";
import privateMarket from "../../../../static/NYSE_About_page_260622_1.gif";
import positiveInnovation from "../../../../static/positive_innovation.png";
import inspiredSolutions from "../../../../static/inspired_solutions.png";
import alignedCommunity from "../../../../static/alighed_community.png";
import empoweredAccess from "../../../../static/empowered_access.png";
import valueBg from "../../../../static/values_bg.png";

import { RevolutionSection } from "../../../modules/signup-page/signup-page/revolution-section";
import { MatrixPanel } from "../matrix-panel";

interface ComponentProps {
  json: {
    sections?: [{ title: string; body: string }];
  };
}

type Props = ComponentProps;

export const WhoWeArePanel = (props: Props) => {
  return (
    <>
      <EmpoweredHumanity />
      <div className="getting-started" style={{ marginTop: "0px" }}>
        <div className="getting-started-container">
          <Mission />
          <OurVision />
          <Values />
          < MatrixPanel json={{ ListId: "In0Eepm1pEqxHRgkyUoN8Q", listItemRow: 6 }} />
          <div style={{ marginTop: '-20px' }}>
            < MatrixPanel json={{ ListId: "aq3bBDfKSgS0TB8HuFGmaQ", listItemRow: 6 }} />
          </div>
          <div style={{ marginTop: '-20px' }}>
            < MatrixPanel json={{ ListId: "Q3tLACxBSzCLpuQVlgWyAQ", listItemRow: 6, showIcons: true }} />
          </div>

          <RevolutionSection />
        </div>
      </div>
      {/* <OurFounder /> */}
    </>
  );
};

const VALUES = [
  {
    id: "collaborative-partners",
    description: "We are inspired problem solvers just like the entrepreneurs we serve.",
    more: (
      <>
        <p>
          Entrepreneurs believe deeply in a brighter future and must make the impossible happen every day. Problems are simply opportunities to deliver new solutions.
        </p>
        <p>
          Radivision is inspired to solve startup and investor challenges with our new, unique solutions - to help everyone grow wealth and deliver more products and services that improve our world.
        </p>
      </>
    ),
    logo: inspiredSolutions,
  },
  {
    id: "powerful-communication",
    description: "Successful entrepreneurship is a team sport.",
    more: (
      <>
        <p>
          Making the impossible happen requires an aligned team to deliver a “whole that is greater than the sum of its parts.”
        </p>

        <p>
          In the challenging startup world, Radivision is delivering new content marketing and investor communication solutions, with your success as our goal. We are on your team!        </p>
      </>
    ),
    logo: alignedCommunity,
  },
  {
    id: "passionate-excellence",
    description: "Speed and efficiency are the currency of success.",
    more: (
      <>
        <p>
          Directly connecting startups and investors, and empowering them with new tools, information, and support grows everyone's success.
        </p>

        <p>
          Uniquely leveraging entertainment is a powerful way to engage and educate consumers and help them grow wealth.
        </p>
      </>
    ),

    logo: empoweredAccess,
  },
  {
    id: "inspired-solutions",
    description: "Delivering valuable solutions for the world’s biggest problems creates the highest shareholder value.",
    more: (
      <>
        <p>
          We are passionate about supporting the startups delivering powerful new solutions for humanity, while also helping everyone share in the equity wealth created in the process.
          Our commitment to quality and excellence is the key to succeeding against the odds.
        </p>
      </>
    ),
    logo: positiveInnovation,
  },
];
const Values = () => {
  return (
    <>
      <div className="mission-content" style={{ marginTop: '20px', textAlign: 'center' }}>
        <h1 className="mission-title">Values</h1>
      </div>

      <div id="values">
        <div className="inner">
          <div className="header">
            {/* <div className="logo">
              <img src={valuesLogo} />
            </div> */}
            {/* <div className="description">Radivision’s Values are the Foundation of Our Brand</div> */}
          </div>
          <div className="values-row">
            {VALUES.map((value) => {
              return <FlipCard value={value} key={`value-${value.id}`} />;
            })}
          </div>
        </div>
      </div>
    </>
  );
};

const FlipCard = ({ value }) => {
  const [isHover, setIsHover] = React.useState(0);

  const onMouseEnter = React.useCallback(() => {
    setIsHover(1);
  }, [isHover]);

  const onMouseLeave = React.useCallback(() => {
    setIsHover(0);
  }, [isHover]);

  return (
    <div
      className={`value-box flip-card ${isHover ? "is-hover" : ""}`}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <div className="flip-card-inner">
        <div className="flip-card-front" style={{ backgroundImage: `url('${valueBg}')` }}>
          <div className="logo">
            <img src={value.logo} />
          </div>
          <div className="description">{value.description}</div>
        </div>
        <div className="flip-card-back" style={{ borderRadius: "30px" }}>{value.more}</div>
      </div>
    </div>
  );
};
const EmpoweredHumanity = () => {
  return (
    <div
      id="empowered-humanity">
      <div className="shade"></div>
      <div className="north-star-sign">
        <img src={northStarSign} />
      </div>
    </div>
  );
};
const OurVision = () => {
  return (
    <>
      <div className="mission-content space-top">
        <h1 className="mission-title">Founder</h1>
        <h2 className="mission-sub-title">Asked by VCs to fix the last liquidity crisis &ndash; back with Radivision to deliver new capital, liquidity &amp; wealth access everyone</h2>
      </div>
      <div id="our-vision">
        <div className="shade"></div>
        <div className="inner">
          <div className="thumbnail">
            <img src={privateMarket} />
          </div>
          <div className="text" style={{ padding: "0px" }}>
            <div className="section north-star" style={{ margin: "0px 0px 40px 0px" }}>
              <p>When the IPO market broke the first time, venture capital leaders called Mona DeFrawi.</p>
              <p>
                In 2008, after taking VC-backed startups public over a decade, building two economic development and tech commercialization offices, and raising CapGen Financial’s $500M debut PE fund, VC leaders asked Mona to help “fix the IPO Crisis.” She did. Mona built InsideVenture, the first Private Market platform as an IPO on-ramp to connect public, PE, and late-stage investor funding into pre-IPO companies, restoring venture liquidity and defining a new category: the Private Markets (acquired; now part of Nasdaq Private Market).
              </p>
              <p>
                VCs and Wall Street leveraged the Private Markets to fuel the unicorn investing trend, which kept companies private longer, and further concentrated the upside at the top, leading to fewer IPOs and today’s eventual liquidity crisis. Today, only 0.05% of startups seeking capital get funded, and only 1% of those ever reach the public markets. Retail investors have been shut out of startup wealth creation for 25+ years, driving the highest income inequality in the G7.
              </p>
              <p>
                Across her career Mona has served on 14 startup teams and organizations &ndash; executing IPOs for the first four, founding and leading the last four as CEO &ndash; and raised billions in capital along the way. From childhood war refugee to Forbes “Most Powerful Women in Technology” and “Top 100 Women in Fintech,” she has spent more than three decades at the intersection of startups, venture capital, and Wall Street.
              </p>
              <p>
                Radivision is the solution for today’s broken capital markets: an AI-powered social platform that educates, engages, and refers everyday investors into private market and IPO opportunities through our SEC-compliant partners. It’s the critical missing infrastructure &ndash; the new IR &ndash; built to unlock ~$25T in untapped global retail capital, to fund the worthy innovators today’s capital markets don’t support, reopening the path to IPOs, and restoring wealth access for ordinary Americans.
              </p>
              <p>
                She conceived private markets. She restored liquidity once, and she’s doing it again. Radivision is opening the new retail private and IPO markets movement &ndash; getting more startups funded, reinvigorating Silicon Valley and Wall Street with more startups and IPOs &ndash; and helping everyone invest like an angel and make money like a millionaire.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const Mission = () => {
  return (
    <section className="mission-section" style={{ padding: "0px 20px" }}>
      <div className="mission-content">
        <h1 className="mission-title">Mission</h1>
        <h2 className="mission-sub-title">Empowering private market &amp; IPO participation and prosperity for everyone.</h2>
        <p className="mission-description">
          Entrepreneurship and its equity creation are the most powerful ways to improve the world and grow wealth. 
          Radivision believes broader participation in this ecosystem will transform how wealth is created and shared, 
          while funding needed innovation. We engage, educate, and connect retail investors to private and IPO opportunities, thereby 
          bringing transparency, access, and insight to a market historically reserved for institutions.
        </p>
      </div>
    </section>
  );
};
